module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-10__e7e72879a59d8648ebbd85c15fde753a.png";